<template>
  <v-container class="admin-dashboard" grid-list-md>
    <auth-form></auth-form>
    <v-layout row v-if="isAuth">
      <v-flex md6 class="my-5">
        <v-card>
          <v-toolbar color="green" dark>
            <v-toolbar-title>
              Manage Projects
            </v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile @click="handleLink(`/admin/createProject`)">
              <v-list-tile-action>
                <v-icon color="primary">star</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="'Create new project'"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="handleLink(`/admin/createContributor/`)">
              <v-list-tile-action>
                <v-icon color="primary">account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content v-text='`Manage contributors`'></v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="handleLink(`/admin/portfolio/`)">
              <v-list-tile-action>
                <v-icon color="primary">book</v-icon>
              </v-list-tile-action>
              <v-list-tile-content v-text='`Manage Portfolios`'></v-list-tile-content>
            </v-list-tile>
            <v-subheader inset>
              Existing projects
            </v-subheader>
            <v-divider inset></v-divider>
            <v-list-tile
              v-for="project in projects"
              :key="project.uri"
              @click="handleLink(`/admin/createProject/${project.id}`)"
            >
              <v-list-tile-action>
                <v-icon color="primary" v-if="project.publish">turned_in</v-icon>
                <v-icon color="primary" v-if="!project.publish">turned_in_not</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="project.title"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex md6 class="my-5">
        <v-card>
          <v-toolbar color="green" dark>
            <v-toolbar-title>
              Other Actions
            </v-toolbar-title>
          </v-toolbar>
          <v-btn block :to="`/admin/event/`">
            Manage Events
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db } from '@/db.js'
import authForm from '@/components/authForm.vue'

export default {
  name: 'adminDashboard',
  components: {
    authForm
  },
  data () {
    return {
      projects: []
    }
  },
  firestore: {
    projects: db.collection('projects')
  },
  computed: {
    isAuth () {
      return this.$store.state.isAuth
    }
  },
  methods: {
    handleLink (url) {
      let urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$' + // fragment locator
        '',
        'i' + // string to match
        '')
      const isUrl = urlPattern.test(url)

      // if (isUrl) {
      // window.open(url)
      // } else {
      this.$router.push(url)
      // }
    }
  }
}
</script>
